import {addFields} from '../search/add_fields';
import {Basics} from '../search/basics';
import {searchFormEvents} from '../search/search_form_events';
import {searchFormHelpers} from '../search/search_form_helpers';
import {fieldEnhancements} from '../search/field_enhancements';
import {selectToButton} from '../search/select_to_button';
import {Field} from '../search/field';
import {Fields} from '../search/fields';
import LocationSearch from '../search/location_search';
import {SearchItemContainer} from '../search/search_item_container';

var locationFields = []; // hold a list of field names that should be grouped in the location section
var existingLocations; // holds locations that were part of the search criteria when the form first loads
var locationSearch;
var firstLoad = true; // some things (like event binding) only need to be done once, the on the first load
var filterChangedCallback;
var startWithFilterPanel = null;

function init(_existingLocations, _startWithFilterPanel = false, _filterChangedCallback) {

  locationFields = mapSupport.locationFields;
  existingLocations = _existingLocations;
  startWithFilterPanel = _startWithFilterPanel;
  window.dispatchEvent(searchFormEvents.filterFirstInitialized(startWithFilterPanel));

  Basics.previous_mls_ids = Basics.mls_id().val();

  enlivenateForm();
  addFields.init();

  if (_filterChangedCallback) {
    filterChangedCallback = _filterChangedCallback;
    bindEvents();
  } else {
    // TODO: Doing this so we don't crash.  Might not need the callback at all.
    filterChangedCallback = function(count, expressions)  {
      console.log("Filter changed callback: Undefined by software")
    }
  }

  // Moved this call out of bindEvents so, if bindEvents is called
  // again, this event isnt fired multiple times.
  window.addEventListener('searchForm:fieldsReloaded', function(e) {
    if (e.detail)
      enlivenateForm(e.detail.existing_locations);
    else
      enlivenateForm();
  });


  handleiPhoneMultiselectBug();

  firstLoad = false;
}



function getAndAddFieldsToForm(fields) {

  var fieldStrings = fields.map(function(f) {
    return f.fieldStr;
  });

  var data = {
    _fields: fieldStrings.join(","),
    _mls_ids: (Basics.mls_id().val() || []).join(',')
  };

  var propertyData = (Basics.propertyTypeValues() !== null) ? Basics.propertyTypeValues() : Basics.propertyClassValues();

  data._property_types = propertyData.join(',');

  return $.ajax({
    url: routes.form_fields_path(),
    data: data,
    dataType: "html",
    success: function(html) {
      insertFieldIntoForm(html, fields);
      applyJsFieldEnhancements();
      
      //Check the checkbox to ensure its enabled
      var checkboxFieldId = $(html).find('[type=checkbox].filter_item_container').first().attr('id');
      if($('#' + checkboxFieldId).prop('checked') == false)
      {
        $('#' + checkboxFieldId).trigger('click');
      }
      
      //scroll to container
      var collapsibleElement = $('#' + checkboxFieldId).closest('.c-card');

      expandContainer(collapsibleElement);

      var scrollTarget = collapsibleElement.outerHeight() + collapsibleElement.position().top;
      if (collapsibleElement.outerHeight() > $('#filterPanel').innerHeight()) {
        scrollTarget = collapsibleElement.position().top;
      }
      bindDateExchange();
      bindRelativeTimeAndDirection();

      if (fields.length == 1) {
        $("input[type=checkbox][name='search_fields[" + fields[0].groupName + "." + fields[0].fieldStr.replaceAll('"','').replaceAll(' ','_') + "][value]']").trigger('click');
      }

      // There is no "scroll height reset" event.  So even though we added a new
      // Item to the content panel, the scroll bar doesnt know about it.  It's
      // current scrollHeight is the same as it was before we added this.
      // But if we wait a skosh, it will know, we can scroll and everybody is happy.
      setTimeout(function () {
        var scrollTarget = $('#filterPanel')[0].scrollHeight - collapsibleElement.outerHeight();
        $('#filterPanel').scrollTop(scrollTarget);
        setContainerFocus(collapsibleElement,true);
      }, 500);
    }
  });
}

function insertFieldIntoForm(html, fields) {
  var field = fields[0];
  var $html = $(html);
  var isLocationField = (locationFields.indexOf(field.id) >= 0)

  var addTo = (isLocationField) ? $('#locationFields') : $('#added-fields');

  // If the field is a part of a boolean group, and part of that group has 
  // already been added to the form, then we need extract just the checkboxes
  // from the html and insert them into the right section.
  if (field.domain === "CustomFields") {
    var container = groupContainer(field.groupName);
    if (field.type === 'Boolean' && container !== null) {
      addTo = container.find('.controls');
      $html = $(html).find('.checkboxen');
    }
  }

  // TODO MWEB-2659: When the form is reloaded after changing the property type or mls, we
  // need to know which fields were manually added so they can be restored to the
  // form if they still apply. This currently works for regular fields but not for
  // boolean group fields. Those will be dropped.
  $html = $($html).addClass('userAddedField');

  if (isLocationField) {
    // Make sure this is above the drawing stuff
    $html.insertBefore("#drawingsSelectDiv");
  }
  else {
    if (addTo.find('#OpenHouses_filter_item_container'))
      $html.insertBefore('#OpenHouses_filter_item_container');
    else if (addTo.find('#TourOfHomes_filter_item_container'))
      $html.insertBefore('#TourOfHomes_filter_item_container');
    else
      addTo.append($html);
  }
}

function groupContainer(name) {
  var group;
  group = $('#added-fields').find("[data-group='" + name + "']");
  if (group.length > 0) {
    return group;
  } else {
    return null;
  }
}

function bindEvents() {
  if(!firstLoad){
    return;
  }

  $(document).off('focus', "#added-fields :input[type=text]");
  $(document).on('focus', "#added-fields :input[type=text]", function() {
    $(this).attr("oldVal",$(this).val());
  });

  $(document).off('blur', "#added-fields :input[type=text]");
  $(document).on('blur', "#added-fields :input[type=text]", function() {
    var changedItem = $(this);
    if (changedItem.attr("oldVal") == $(this).val())
      return;

    // If the item's container was not checked, check it now
    checkContainer(changedItem.closest('.c-card'), true);

    if (changedItem.closest(".controls.split").length == 1) {
      if ($(changedItem.closest(".controls.split")[0]).hasClass('contains-date')) {
        // Only the relative date controls have the contains-date class
        updateRelativeDateSummary($(changedItem.closest(".controls.split")[0]));
      } else {
        updateSplitControlsSummary($(changedItem.closest(".controls.split")[0]));
      }
    } else {
      changedItem.closest('.c-card').find('.c-card-enable-summary').text(changedItem.val());
    }
    var serializedForm = searchFormHelpers.formSerializer();
    reloadData(function (data) {
      filterChangedCallback(data.count, data.expressions);
    }, serializedForm);
  });
  $(document).off('change', '#added-fields');
  $(document).on('change', "#added-fields type:not(select), #added-fields input[type=checkbox]", function(e) {
    fieldCheckboxChanged(e.target);
  });

  $(document).off('change', ".relative_date_field, .relativeDateField");
  $(document).on('change', ".relative_date_field, .relativeDateField", function() {
    if ($(".select2-container--open").length > 0) {
      // Any time a select2 is open, we want to let the user
      // finish what they are doing.
      return;
    }

    updateRelativeDateSummary($($(this).parent()[0]));

    var serializedForm = searchFormHelpers.formSerializer();
    reloadData(function (data) {
      filterChangedCallback(data.count, data.expressions);
    }, serializedForm);
  });

  $(document).off('change', "#basics-content .date_field");
  $(document).on('change', "#basics-content .date_field", function() {
    if ($(".select2-container--open").length > 0) {
      // Any time a select2 is open, we want to let the user
      // finish what they are doing.
      return;
    }

    // If the item's container was not checked, check it now
    checkContainer($(this).closest('.c-card'), true);

    updateSplitControlsSummary($($(this).parent()[0]));

    var serializedForm = searchFormHelpers.formSerializer();
    reloadData(function (data) {
      filterChangedCallback(data.count, data.expressions);
    }, serializedForm);
  });

  $(document).on('focus', '#locationFields input[type=text]', function(args) {
    if($(this).hasClass('select2-search__field')) { return; }
    var oldValue = $(this).val().trim();
    $(this).one('blur', function(args) {
      var newValue = $(this).val().trim();

      if(oldValue === newValue) {
        return;
      } else {
        $(this).closest('.c-card').find('.c-card-enable-summary').text(newValue);
        var fieldName = $(this).attr("id").replace(/search_fields_|_value/g, '');
        var newValuesArray = newValue.split(/\s*,\s*/);

        var placeholderText = $('#locationSearch').attr('data-placeholder-text');
        locationSearch = new LocationSearch($('#locationSearch'), {
          searchUrl: window.omniSearchUrl,
          changeCallback: searchFormHelpers.findCount,
          existingLocations: existingLocations,
          placeholderText: placeholderText,
          portalSlug: window.portal_slug,
          useHiddenInputs: false,
          suppressChangeEvents: true
        });

        if (oldValue.length > 0) {
          var oldValuesArray = oldValue.split(/\s*,\s*/);
          oldValuesArray.forEach(function(oldValue) {
            locationSearch.removeValue(fieldName + '_' + oldValue);
          });
        }

        newValuesArray.forEach(function(newValue) {
          locationSearch.selectValue(fieldName + '_' + newValue);
        });
        setTimeout(clearLocationSearch, 0);
        setTimeout(function() { locationSearch.resetPlaceholder(); }, 0);
      }
      var serializedForm = searchFormHelpers.formSerializer();
      reloadData(function (data) {
        filterChangedCallback(data.count, data.expressions);
      }, serializedForm);

    });
  });
  
  $(document).off('change', "#locationFields select, #locationFields input, #drawingsSelect");
  $(document).on('change', "#locationFields select, #locationFields input, #drawingsSelect", function() {
    if ($(this).hasClass('filter_item_container') || this.type == "text" || this.type == 'single-select') {
      return;
    }
    if ($(".select2-container--open").length > 0) {
      // Any time a select2 is open, we want to let the user
      // finish what they are doing.
      return;
    }
    var serializedForm = searchFormHelpers.formSerializer();
    reloadData(function (data) {
      filterChangedCallback(data.count, data.expressions);
    }, serializedForm);
  });

  $(document).on('keyup',  '.filter_item_container input[type=text]:not(.select-range-field input)', $.flexmlsUi.debounce(function(){
    if ($($(this).closest('.c-card').find('input[type=checkbox].filter_item_container')[0]).prop('checked') == false) {
      checkContainer($($(this).closest('.c-card')), true);
    }
  },200));

  $(document).off('keyup',  '.select-range-field input');
  $(document).on('keyup',  '.select-range-field input',  function() {
    Fields.selectFromRange(this);
    var serializedForm = searchFormHelpers.formSerializer();
    reloadData(function (data) {
      filterChangedCallback(data.count, data.expressions);
    }, serializedForm);
  });

  $(document).off('change', '.select-range-field select');
  $(document).on('change', '.select-range-field select', function() {
    Fields.rangeFromSelect(this); 
    updateListings()
  });

  // CONVERTED: This has been moved to search_filters stimulus controller
  $(document).off('change', 'select:not(#locationSearch,#drawingSelect,#templateSelect)');
  $(document).on('change', 'select:not(#locationSearch,#drawingsSelect,#templateSelect)', function(e) {
    selectChanged(e.target);
  });

  $(document).off('select2:close');
  $(document).on('select2:close', function(e) {
    select2Changed(e.target);
  });

  $(document).off('addFields:add');
  $(document).on('addFields:add', function(e, fields) {
    getAndAddFieldsToForm(fields);
  });

  // Setup  links under gear dropdown
  $(document).off('click', '.removeFieldLink');
  $(document).on('click', '.removeFieldLink', function(e) {
    e.preventDefault();
    removeField(e.target);
  });

  $(document).off('click', 'a.search-operator');
  $(document).on('click', 'a.search-operator', function(e) {
    searchOperatorChanged(e);
  });

  $(document).off('click', 'a.remove-group');
  $(document).on('click', 'a.remove-group', Fields.removeGroup);  // for boolean groups


  $('#filterPanelContent').one('DOMNodeInserted', function(event){
      // The date exchange icon and the relative time and direction are handled
      // differently and cannot be bound at the document level.  When we load the
      // panel and insert the html from the server, those items are not recognized
      // yet.  We have to wait for the DOMNodeInserted event to fire.  At this
      // point, jquery can see them and we can bind them.  We only have to do this
      // 1 time.  If new dates are added later, these functions will get called
      // from the add event.
      bindDateExchange();
      bindRelativeTimeAndDirection();
  });

  $(document).on('shown.bs.collapse', function(e) {
    // The collapsible container has fired the 'uncollapse' event
    var collapsibleElement = $($(e.target).closest('.c-card')[0]);
    // Make sure the content is visible
    scrollToContainer($(collapsibleElement));
    // Focus on the first element in the container
    setContainerFocus($(collapsibleElement,false));
  });

  $(document).off('change', ':input[type=checkbox].filter_item_container');
  $(document).on('change', ':input[type=checkbox].filter_item_container', function(e) {
    filterCheckboxChanged(e.target);
  });
}

function fieldCheckboxChanged(target) {
    var changedItem = $(target);
    if (changedItem.hasClass('filter_item_container')) {
      return;
    }

    // If the item's container was not checked, check it now
    checkContainer(changedItem.closest('.c-card'), true);

    if ($(".select2-container--open").length > 0) {
      // Any time a select2 is open, we want to let the user
      // finish what they are doing.
      return;
    }

    if (changedItem.is("input[type=checkbox]")) {
      updateBooleanGroupSummary(changedItem);
    } else if (changedItem.is("input[type=select]") || changedItem.is["select"]) {
      updateSelectSummary(e.target);
    } else {
      console.log("Summary needed for item type: " + changedItem.prop('nodeName'));
    }
    var serializedForm = searchFormHelpers.formSerializer();
    reloadData(function (data) {
      filterChangedCallback(data.count, data.expressions);
    }, serializedForm);
}

function bindDateExchange() {
  $('.exchange_icon:not(.bound)').addClass('bound').click(function() {

    // If the item's container was not checked, check it now
    checkContainer($($(this).closest('.c-card')), true);

    searchFormHelpers.toggleDateRelativity($(this));
    //searchFormHelpers.findCount();
    var isChangedToDateRange = ($('#'+ $(this).attr('data-field-id').replace(/\"|\./g, '').replace(' ','_') + "_relative_container").css('display') == 'none')

    if (isChangedToDateRange) {
      updateSplitControlsSummary($($(this).parent().find(".controls.split")[0]));
    } else {
      updateRelativeDateSummary($('#'+ $(this).attr('data-field-id').replace(/\"|\./g, '').replace(' ','_') + "_relative_container"));
    }

    updateListings(isChangedToDateRange);
  });

}
function bindRelativeTimeAndDirection() {
  $('.relative_time:not(.bound), .relative_direction:not(.bound)').addClass('bound').click(function() {

    // If the item's container was not checked, check it now
    checkContainer($($(this).closest('.c-card')), true);

    var vals = $(this).hasClass("relative_time") ? ['days','months','years'] : ['back','ahead'] ;
    var currentVal = $(this).text();
    for (var x=0; x < vals.length; x++) {
      if (vals[x] == currentVal) {
        var new_val = x == vals.length-1 ? vals[0] : vals[x+1] ;
        $(this).text(new_val);
        $( "input[name='" + $(this).data("for") + "']").val(new_val);
      }
    }
    updateRelativeDateSummary($($(this).closest('.contains-date')[0]));

    updateListings();
  });
}

function updateStatusDates(myStatuses) {
  Basics.update_status_date_fields();
}



function updateListings(isChangedToDateRange = false, isBasicsChange = false) {
  var serializedForm = searchFormHelpers.formSerializer();
  reloadData(function(data){
    if (isChangedToDateRange == true) {
      // We dont have date information filled in yet for the date range.
      // We need to get it from the server now that the form has the
      // date fields we want then resend it so the filter reflects the
      // dates filled in by the server.  THIS IS A TEMPORARY FIX UNTIL
      // WE UPDATE THE WAY DATES ARE HANDLED.
      updateListings();
    } else {
      filterChangedCallback(data.count, data.expressions);
    }
  }, serializedForm, isBasicsChange);
}

// This runs when the form is initially loaded and after all the fields are reloaded
function enlivenateForm(_existing_locations) {
  setupLocationSearch(_existing_locations);
  
  applyJsFieldEnhancements();

  fixMobileDropdowns();

  Basics.update_status_date_fields();

  // FLEX-3837 - Only show the status selector if there is more than one status
  // available to select.
  if (Basics.status_select().find('option').length === 1) {
    Basics.status_select().parents('.fieldWrapper').hide();
  } 
}

function enlivenateBasics() {
  fieldEnhancements.multiSelectDropdowns();
  Basics.update_status_date_fields();
  fixMobileDropdowns();
  // FLEX-3837 - Only show the status selector if there is more than one status
  // available to select.
  if (Basics.status_select().find('option').length === 1) {
    Basics.status_select().parents('.fieldWrapper').hide();
  } 
}

function setupLocationSearch(_existing_locations) {
  if (_existing_locations) {
    existingLocations = _existing_locations;
  }
  var placeholderText = $('#locationSearch').attr('data-placeholder-text');
  locationSearch = new LocationSearch($('#locationSearch'), {
    searchUrl: window.omniSearchUrl,
    changeCallback: searchFormHelpers.findCount,
    existingLocations: existingLocations,
    placeholderText: placeholderText,
    portalSlug: window.portal_slug,
    useHiddenInputs: false,
    suppressChangeEvents: true
  });

  // Now that locationSearch has loaded the existing locations, clear the 
  // pills and show the placeholder text.
  setTimeout(clearLocationSearch, 0);

  $('#locationSearch').on('locationSearch:selecting',   handleLocationSearchSelecting  );
  
  $('#locationSearch').on('select2:select', function(){
    setTimeout(clearLocationSearch, 0);
  });

  $('#locationSearch').on('locationSearch:unselecting', handleLocationSearchUnselecting);

  syncIndividualLocationFieldsToMainLocationField()
}

function syncIndividualLocationFieldsToMainLocationField() {
  
  $(document).on('select2:select', '#locationFields select', function(args) {
    if(typeof args.params !== 'undefined'){
      var fieldName = args.target.dataset.fieldName;
      var label = args.params.data.id;
      var value = fieldName + '_' + label;
      locationSearch.selectValue( value, label );
      setTimeout(clearLocationSearch, 0);
    }
  });
  
  $(document).on('select2:unselect', '#locationFields select', function(args) {
    var fieldName = args.target.dataset.fieldName;
    var label = args.params.data.id;
    var value = fieldName + '_' + label;
    locationSearch.removeValue( value );

    setTimeout(function() { locationSearch.resetPlaceholder(); }, 0);      
  }); 
  
  $(document).on('focus', '#locationFields input', function(args) {
    if($(this).hasClass('select2-search__field')) { return; }
    var oldValue = $(this).val().trim();
    $(this).one('blur', function(args) {
      var newValue = $(this).val().trim();

      if(oldValue === newValue) {
        return;
      } else {
        $(this).closest('.c-card').find('.c-card-enable-summary').text(newValue);
        var fieldName = $(this).attr("id").replace(/search_fields_|_value/g, '');
        var oldValuesArray = oldValue.split(/\s*,\s*/);
        var newValuesArray = newValue.split(/\s*,\s*/);

        oldValuesArray.forEach(function(oldValue) {
          locationSearch.removeValue(fieldName + '_' + oldValue);
        });

        newValuesArray.forEach(function(newValue) {
          locationSearch.selectValue(fieldName + '_' + newValue);
        });
        setTimeout(clearLocationSearch, 0);
        setTimeout(function() { locationSearch.resetPlaceholder(); }, 0);      
      }

    });
  });
}

function clearLocationSearch() {
  // Remove the little selection pills. Even though they are hidden, you
  // can still delete them with the backspace key.
  $('.filters-location-search .select2-selection__choice').remove();

  // Select2 still thinks that there are values selected, so it won't show
  // the placeholder. We need to manually add it back in.
  locationSearch.resetPlaceholder();    
}

function handleLocationSearchSelecting(e, fieldName, addedValue, sparkQl) {
  getOrAddField(fieldName).done(function(input) {

    var existingValue = input.val();
    if(input.is('select')){
      let newValues = (existingValue === null) ? [addedValue] : existingValue.concat([addedValue]);
      selectDropdownValues(input, newValues);
      updateSelectSummary(input);
    } else if (input.is('input')) {
      let newValues = '';
      if (existingValue === '') {
        newValues = addedValue;
      } else {
        var valuesArray = existingValue.split(/\s*,\s*/);
        valuesArray.push(addedValue);
        newValues = valuesArray.join(', ');
      }
      input.val(newValues).trigger('change');
      checkContainer(input.closest('.c-card'),true);
      input.closest('.c-card').find('.c-card-enable-summary').text(input.val());
    }
  });
}

function selectDropdownValues(dropdown, values) {
  // Create <option>s for all the selected values
  values.forEach(function(value){
    if (dropdown.find("option[value='" + value + "']").length === 0) {
      // Create a DOM Option and pre-select by default
      var newOption = new Option(value, value, true, true);
      dropdown.append(newOption);
    }
  });

  dropdown.val(values).trigger('change');
}

function getOrAddField(originalFieldName) {
  var deferred = $.Deferred();

  var fieldName = originalFieldName.replace(/"/g, '').replace(/\s/g, '_');

  var inputName = "search_fields[" + fieldName + "][value][]";
  var fieldSelector = "#search_fields_" + fieldName.replace(/\./g, '\\.') + "_value";
  var input = $(fieldSelector);

  if( input.length ) {
    deferred.resolve(input);
  } else {
    var data = {};

    if(originalFieldName.indexOf('.') > 0) {
      data.domain = 'CustomFields';
      data.groupName = originalFieldName.split('.')[0].replace(/"/g, '');
      data.id = originalFieldName.split('.')[1].replace(/"/g, '');
    } else {
      data.id = fieldName;
    }

    var field = new Field(data);
    getAndAddFieldsToForm([field]).done(function() {
      deferred.resolve( $(fieldSelector) );
    });
  }
  return deferred;
}

function handleLocationSearchUnselecting(e, field, removedValue) {
  var input = $("#search_fields_" + field + "_value");
  var oldValue = input.val();

  if(input.is('select')){
    oldValue.splice(oldValue.indexOf(removedValue), 1);
    input.val(oldValue);
    updateSelectSummary(input);
    if (input.find('option:selected').length == 0) {
      checkContainer(input.closest('.c-card'), false);
    }
  } else if (input.is('input')) {
    var valuesArray = oldValue.split(/\s*,\s*/);
    valuesArray.splice(valuesArray.indexOf(removedValue), 1);
    input.val(valuesArray.join(', '));
    input.closest('.c-card').find('.c-card-enable-summary').text(input.val());
    if (valuesArray.length == 0) {
      checkContainer(input.closest('.c-card'), false);
    }
  }
  input.trigger('change');
}

// This is called by by enlivenateForm and when a single field or single group is added
function applyJsFieldEnhancements() {

  fieldEnhancements.multiSelectDropdowns();
  fieldEnhancements.ajaxFieldLists();

  // Setup Boolean Groups
  selectToButton('.boolean-group-operator-select');

  var isIOS = /(iPod|iPhone|iPad)/.test(navigator.userAgent)

  // Setup Date fields
  if (Modernizr.touch && Modernizr.inputtypes.date && isIOS) {
    $('.date_field').each(function() {
      var $this = $(this)
      var newVal = $this.val();
      if (/\d{2}\/\d{2}\/\d{4}/.test(newVal)) {
        var splits = newVal.split('/') // [month, day, year]
        newVal = splits[2]+'-'+splits[0]+'-'+splits[1];
      }
      $this.replaceWith($this.clone().attr('type','date').val(newVal));
    });
  } else {
    $(".date_field").datepicker({format:"mm/dd/yyyy"}).on('changeDate', function(ev){$(this).blur();$(this).datepicker('hide');});
    if (Modernizr.touch)
      $(".date_field").attr("readonly", true);
  }

  // Setup field options dropdown (gear icon)
  $('.dropdown-toggle').dropdown();

}

function handleiPhoneMultiselectBug() {
  // MOBILE-642: hack for iPhone 7 multiselect bug
  // http://stackoverflow.com/questions/20039194/multiple-select-in-safari-ios-7
  // When we leave our select options, select the ones we want and rewrite our options
  if (navigator.userAgent.match(/(iPhone);.*CPU.*OS 7_\d/i)){
    $('select[multiple]').each(function(){
      var select = $(this).on({
        "focusout": function(){
          var values = select.val() || [];
          setTimeout(function(){
            select.val(values.length ? values : ['']).change();
          }, 800);
        }
      });

      var firstOption = '<option value="" disabled="disabled"';
      firstOption += (select.val() || []).length > 0 ? '' : ' selected="selected"';
      firstOption += '>&laquo; Select ' + (select.attr('title') || 'Options') + ' &raquo;';
      firstOption += '</option>';
      select.prepend(firstOption);
    });
  }

}

function fixMobileDropdowns() {
  // Fix for dropdowns on mobile devices
  // https://github.com/twitter/bootstrap/issues/4550#issuecomment-10653502
  $('body').on('touchstart.dropdown', '.dropdown-menu', function (e) {
      e.stopPropagation();
  });

  if (Modernizr.touch) {
    var $body = $('body');
    var $inputs = $('#list_container_form').find(':input');

    $inputs.on('focus', function(e) {
      $body.addClass('fixed-fix');
    });

    $inputs.on('blur', function(e) {
      $body.removeClass('fixed-fix');
      setTimeout(function(){
        window.scrollTo(0, window.scrollY)
      }, 0);
    });

    setTimeout(function(){
      window.scrollTo(0,1);
    }, 20)
  }    
}

function reloadData(successCallback, serializedForm = null, isBasicsChange = false) {
  var post_data = "";
  var user_added_fields = [];

  if (typeof successCallback === 'undefined') {
    successCallback = function() {};
  }

  // Close all dropdowns so they don't get orphaned when the selects are replaced.
  setTimeout(function() {
    $('.select2-hidden-accessible').select2('close');
  }, 1);

  $('a.view-results').text($('a.view-results').attr('data-loading-text'));
  
  $('.userAddedField').each(function() {
    user_added_fields.push($(this).attr('data-field'));
  });

  if (user_added_fields.length) {
    post_data += "_user_added_fields=" + user_added_fields + "&";
  }

  var previousMlsIds = (Basics.previous_mls_ids != null) ? Basics.previous_mls_ids.join(',') : '';
  post_data += "_previous_mls_ids=" + previousMlsIds + "&";

  post_data += (serializedForm != null) ? serializedForm : searchFormHelpers.formSerializer();

  window.dispatchEvent(new CustomEvent('filterForm:reloadStarting'));

  return $.ajax({
    url: $('.filterModalLink').attr('data-filter-url'),
    type: 'POST', // POST is needed here because of the amount of data that is being sent. A GET can result in a 414 URI Too Long Error.
    data: post_data,
    success: function(data) {
      if (isBasicsChange) {
        // If the basics fields caused the update, we need make sure that
        // the basics fields need to be updated.  Pull them from the form.
        // We dont want to replace the entire form!  Just the Basics.
        Basics.previous_mls_ids = Basics.mls_id().val();
        var formString = data.fields;
        var basicsContent = formString.substring(formString.indexOf('<div id="basics-content"'));
        basicsContent = basicsContent.substring(0, basicsContent.indexOf('<div id="added-fields"'));
        $("#basics-content").replaceWith(basicsContent);
        enlivenateBasics();
      }
      $("#viewListingsButton").text(data.message);
      if ($('#viewResultsLink').length > 0) {
        $('#viewResultsLink')[0].childNodes[2].textContent = ' ' + data.message + ' ';
      }
      window.dispatchEvent(searchFormEvents.filterChange(data.filter));
      delete(data.fields);
      successCallback(data);
    },
    error: function() {
      return alertModal('Sorry, there was an error updating the form.');
    }
  });
}

function initAddFields() {
  addFields.init();
}

function setFilterChangedCallback(_filterChangedCallback) {
  filterChangedCallback = _filterChangedCallback;
  // Bind the events using this as the callback function
  bindEvents();
}

function summarizeBooleanOperator(item) {
  let $parent = item.parents('.control-group');
  if ($parent.hasClass('op-not')) {
    return "NOT: ";
  } else if ($parent.hasClass('op-or')) {
    return "OR: ";
  }
  return "";
}
function updateBooleanGroupSummary(changedItem) {
  var summary = "";
  var summary_separator = "";
  changedItem.closest('.bool-group').find('input:checked').each(function() {
    // Get the text and not the other items included with the text.
    summary += summary_separator;
    summary += $(this).next().clone()    //clone the element
    .children() //select all the children
    .remove()   //remove all the children
    .end()  //again go back to selected element
    .text();
    summary_separator = ", ";
  });
  if (summary.length > 0) {
    summary = summarizeBooleanOperator(changedItem) + summary;
  }
  changedItem.closest('.c-card').find('.c-card-enable-summary').text(summary);
}

function updateSelectSummary(target) {
  var resultsArray = [];
  let summary = ''
  $(target).find("option:selected").each(function(){
    if ($(this).val()) {
      resultsArray.push($(this).text());
    }
  });
  summary = resultsArray.join(', ');
  if (summary.length > 0) {
    summary = summarizeBooleanOperator($(target)) + summary;
  }
  $(target).closest('.c-card').find('.c-card-enable-summary').text(summary);
}

function updateSplitControlsSummary(splitControlDiv) {
  var left, right;
  var datepattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
  var currency = "" 
  var removeCommas = false;
  var precision=2;
  
  splitControlDiv.find("input[type=text]").each(function() {
    removeCommas = $(this).hasClass('numeric-no-commas') || removeCommas;
    if (this.id.endsWith('_left')) {
      currency = $(this).hasClass('currency') ? "$" : currency;      
      left = $(this).val();   
    } else if (this.id.endsWith('_right')) {
      currency = $(this).hasClass('currency') ? "$" : currency;
      right = $(this).val();
    }
  });

  splitControlDiv.find("input[type=date]").each(function() {
    if (this.id.endsWith('_left')) {
      left = $(this).val();
      if (/\d{4}-\d{2}-\d{2}/.test(left)) {
        var ymd = left.split('-');
        left = ymd[1] + '/' + ymd[2] + '/' + ymd[0];
      }
      } else if (this.id.endsWith('_right')) {
      right = $(this).val();
      if (/\d{4}-\d{2}-\d{2}/.test(right)) {
        var ymd = right.split('-');
        right = ymd[1] + '/' + ymd[2] + '/' + ymd[0];
      }
    }
  });

  if(!currency){
    precision=3;
  }
  
  var summary = "";
  if (left.length > 0 && right.length > 0) {
    if (isNaN(left) || isNaN(right)) {
      summary = left + " - " + right;
    } else { 
      left = toFixed(left*1, precision);
      right = toFixed(right*1, precision);
      summary = currency + 
                left.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 20}) + 
                "-" + 
                currency + 
                right.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 20});
    }
  } else if (left.length > 0) {
    if (isNaN(left)) {
      summary = left + " +";
    } else {
      left = toFixed(left*1, precision); 
      summary = currency + left.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 20}) + "+";
    }
  } else if (right.length > 0) {
    if (isNaN(right)) {
      if (datepattern.test(right))
        summary += "Before "
      summary += right;
    } else {
      right = toFixed(right*1, precision); 
      summary = currency + "0 - " + currency + right.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 20});
    }
  } else {
    // Empty summary
  }

  if(removeCommas)
  {
    summary = summary.replaceAll(',', '');     
  }
  if (summary.length > 0) {
    summary = summarizeBooleanOperator(splitControlDiv) + summary;
  }
  splitControlDiv.closest('.c-card').find('.c-card-enable-summary').text(summary);
}

function toFixed(num, fixed) {
  var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
  return parseFloat(num.toString().match(re)[0]);
}

function updateRelativeDateSummary(relativeDateDiv) {
  var summary = "";
  relativeDateDiv.find("input[type=text]").each(function() {
    summary += $(this).val();
  });
  relativeDateDiv.find("input[type=hidden]").each(function() {
    summary += " " + $(this).val();
  })
  if (summary.length > 0) {
    summary = summarizeBooleanOperator(relativeDateDiv) + summary;
  }
  relativeDateDiv.closest('.c-card').find('.c-card-enable-summary').text(summary);
}

function handleResetShapesClick(e) {
  e.preventDefault();
  $("#drawingsSelect").empty().trigger("change");
  $('div.drawn-shapes-prompt').hide();
}

function collapseContainer(container) {
  container.removeClass('c-card--expanded');
  container.find('.c-collapsible__title').first().attr('aria-expanded', 'false');
  container.find('.collapse').first().removeClass('in');
  container.find('.collapse').first().attr('aria-expanded','false');
  container.prev('.c-card').prevClass('c-card-next-is-expanded');
}

function expandContainer(container) {
  container.addClass('c-card--expanded');
  container.find('.c-collapsible__title').first().attr('aria-expanded', 'true');
  container.find('.collapse').first().addClass('in').removeAttr('style');
  container.find('.collapse').first().attr('aria-expanded','true');
  container.prev('.c-card').addClass('c-card-next-is-expanded');
}

function checkContainer(container, shouldBeChecked) {
  if (shouldBeChecked) {
    container.find('input[type=checkbox].filter_item_container').prop('checked',true)
    container.find('.c-card-enable-summary').css('color', '#0077d9');
    container.find('.c-collapsible__content.filter_item_container').find('*').removeClass('dont_serialize');
  } else {
    container.find('input[type=checkbox].filter_item_container').prop('checked',false)
    container.find('.c-card-enable-summary').css('color', '#a6a6a6');
    container.find('.c-collapsible__content.filter_item_container').find('*').addClass('dont_serialize');
  }
}

function expandAndScrollContainer(container) {
  expandContainer(container);
  scrollToContainer(container);
}

function scrollToContainer(container) {
  var panelTop = $('#filterPanel').scrollTop();
  var panelBottom = $('#filterPanel').height();
  var myTop = container.position().top;
  var myBottom = myTop + container.height();
  if (myBottom > panelBottom) {
    var scrollTarget = $('#filterPanel')[0].scrollHeight - container.outerHeight();
    $('#filterPanel').scrollTop(scrollTarget);
  } // else the container is already totally visible.  No worries.  Unless the item is to big to fit in the window.  :(
}

function setContainerFocus(container,focus_special_fields) {
  var focusable = container.find('.c-collapsible__content.filter_item_container').find('button, input:not([type=hidden]):not(:disabled), select, textarea, [tabindex]:not([tabindex="-1"])');
  if (focusable.length > 0) {
    if ($(focusable[0]).hasClass('date_field')) {
      if (focus_special_fields) {
        $(focusable[0]).focus();
      }
    } else if ($(focusable[0]).hasClass('select2-hidden-accessible')) {
      if (focus_special_fields) {
        $(focusable[0]).focus();
        $(focusable[0]).select2('open');
      }
    } else {
      $(focusable[0]).focus();
    }
  }
}

function selectChanged(target) {
    SearchItemContainer.checkContainerForSelectChange(target);

    if ($(".select2-container--open").length > 0) {
      // Any time a select2 is open, we want to let the user
      // finish what they are doing.
      return;
    }
    if (!$(target).hasClass('boolean-group-operator-select')) {
      updateSelectSummary(target);
    }
    if (Basics.ids.includes(target.id)) {
      if (target.id == 'search_fields_MlsStatus_value' || target.id == 'search_fields_StandardStatus_value') {
        var myStatuses = $(target).val();
        updateStatusDates(myStatuses);
      } else if (target.id == 'search_fields_MlsId_value') {
        // This is the special case where we really do want to reload the entire form.
        Fields.reload(function (data) {
          filterChangedCallback(data.count, data.expressions);
          $('.c-card-group').flexCardGroup();
          bindDateExchange();
          bindRelativeTimeAndDirection();  
        });
        return;
      }

    }
    var serializedForm = searchFormHelpers.formSerializer();
    reloadData(function (data) {
      filterChangedCallback(data.count, data.expressions);
    }, serializedForm);
}

function select2Changed(target) {
    if ($(".select2-container--open").length > 0) {
      // Any time a select2 is open, we want to let the user
      // finish what they are doing.
      return;
    }
    updateSelectSummary(target);
    if (Basics.ids.includes(target.id)) {
      if (target.id == 'search_fields_MlsStatus_value' || target.id == 'search_fields_StandardStatus_value') {
        var myStatuses = $(target).val();
        updateStatusDates(myStatuses);
      } else if (target.id == 'search_fields_MlsId_value') {
        // This is the special case where we really do want to reload the entire form.
        Fields.reload(function (data) {
          if (filterChangedCallback)
            filterChangedCallback(data.count, data.expressions);
          $('.c-card-group').flexCardGroup();
          bindDateExchange();
          bindRelativeTimeAndDirection();  
        });
        if (filterChangedCallback)
          return;
      }
    }
    var serializedForm = searchFormHelpers.formSerializer();
    reloadData(function (data) {
      filterChangedCallback(data.count, data.expressions);
    }, serializedForm);
}

function removeField(target) {
    
    var id = $(target).attr('id'); 
    var checkbox = Fields.getFieldCheckboxSelector(id);
    var checkboxSelected = checkbox ? checkbox.prop('checked') : false;

    Fields.remove(id);
    if( checkboxSelected )
    {
      var serializedForm = searchFormHelpers.formSerializer();
      reloadData(function (data) {
        filterChangedCallback(data.count, data.expressions);
      }, serializedForm);
    }
}

function searchOperatorChanged(e) {
    var $target = $(e.target);
    var $container = $(e.target).closest('.c-card');
    // If the item's container was not checked, check it now
    checkContainer($container, true);

    let summary = $container.find('.c-card-enable-summary').html();

    let $parent = $target.parents('.control-group');
    if ($parent.hasClass('op-not') && summary.startsWith('NOT: ')) {
      summary = summary.substring(5);
    } else if ($parent.hasClass('op-or') && summary.startsWith('OR: ')) {
      summary = summary.substring(4);
    }
    if (summary.length > 0) {
      let newValue = $target.attr('data-operator')
      if (newValue != 'and') {
        summary = newValue.toUpperCase() + ': ' + summary
      }
    }
    $container.find('.c-card-enable-summary').html(summary);

    Fields.setOperator(e);
    var serializedForm = searchFormHelpers.formSerializer();
    reloadData(function (data) {
      filterChangedCallback(data.count, data.expressions);
    }, serializedForm);
}

function filterCheckboxChanged(target) {
    var collapsibleElement = $($(target).closest('.c-card')[0]);
    
    if ($(target).prop("checked") == true) {
      // Remove class telling form not to serialize these elements
      collapsibleElement.find('.c-collapsible__content.filter_item_container').find('*').removeClass('dont_serialize');
      // Make sure the summary text is not grayed out
      collapsibleElement.find('.c-card-enable-summary').css('color', '#0077d9');
      expandContainer(collapsibleElement);
      // Need to give the browser some time to realize the scroll height has changed.
      setTimeout(function () {
        // Now we can scroll to the target if we need to
        scrollToContainer(collapsibleElement);
        // And set the focus to on the first element
        setContainerFocus(collapsibleElement,false);
      }, 200);
    } else {
      // Tell the form not to serilize elements in this container
      collapsibleElement.find('.c-collapsible__content.filter_item_container').find('*').addClass('dont_serialize');
      // Gray out the summary text
      collapsibleElement.find('.c-card-enable-summary').css('color', '#a6a6a6');
    }

    var serializedForm = searchFormHelpers.formSerializer();
    reloadData(function (data) {
      filterChangedCallback(data.count, data.expressions);
    }, serializedForm);
}

export var searchForm = {
  init: init,
  enlivenateForm: enlivenateForm,
  initAddFields: initAddFields,
  setFilterChangedCallback: setFilterChangedCallback,
  bindDateExchange: bindDateExchange,
  bindRelativeTimeAndDirection: bindRelativeTimeAndDirection,
  handleResetShapesClick: handleResetShapesClick,
  startWithFilterPanel: startWithFilterPanel,
  selectChanged: selectChanged,
  select2Changed: select2Changed,
  removeField: removeField,
  searchOperatorChanged: searchOperatorChanged,
  filterCheckboxChanged: filterCheckboxChanged,
  updateStatusDates: updateStatusDates,
  enlivenateBasics: enlivenateBasics,
  getAndAddFieldsToForm: getAndAddFieldsToForm,
  fieldCheckboxChanged: fieldCheckboxChanged
};
